/** Страница регистрации на чемпионат «Пилоты будущего». */
export const DEFAULT_REGISTER_URL = 'https://xn--n1abebi.xn--90acagbhgpca7c8c7f.xn--p1ai/pilots-of-the-future/';
